(() => {
  const containers = document.querySelectorAll('.stack-trigger-container');

  containers.forEach((container) => {
    const stackTriggerTl = gsap.timeline({
      once: true,
      scrollTrigger: {
        trigger: container,
        start: 'top bottom-=300px',
      },
    });

    Array.from(container.children).forEach((child) => {
      stackTriggerTl.fromTo(child, {
        transform: 'translateY(-40px)',
        opacity: 0,
      }, {
        transform: 'translateY(0)',
        opacity: 1,
        duration: 0.5,
        ease: 'power2',
        delay: 0.4,
      }, '<');
    });
  });
})();
